import { lazy } from 'react';

const HomeContainer = lazy(() => import('./HomeContainer')),
  SearchContainer = lazy(() => import('./SearchContainer')),
  CheckoutContainer = lazy(() => import('./CheckoutContainer')),
  ProductDetails = lazy(() => import('./ProductDetail')),
  ConfirmationContainer = lazy(() => import('./ConfirmationContainer')),
  InvoiceContainer = lazy(() => import('./InvoiceContainer')),
  MyProfileContainer = lazy(() => import('./MyProfileContainer')),
  MyBookingContainer = lazy(() => import('./MyBookingContainer')),
  AmendmentContainer = lazy(() => import('./AmendmentContainer')),
  AmendmentInvoiceContainer = lazy(() => import('./AmendmentInvoiceContainer')),
  HcnUpdateContainer = lazy(() => import('./HcnUpdateContainer'));


export {
  HomeContainer,
  SearchContainer,
  CheckoutContainer,
  ProductDetails,
  ConfirmationContainer,
  InvoiceContainer,
  MyProfileContainer,
  MyBookingContainer,
  AmendmentContainer,
  AmendmentInvoiceContainer,
  HcnUpdateContainer
};
